/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/4/2022.
 */

import React from 'react'
import {injectIntl} from 'react-intl';
import {Select} from '@scuf/common'
import {fetchUsers} from "../../api/Users";

class UsersSelect extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            users: [],
            selectedUser: this.props.selectedUser,
        }

    }

    componentDidMount() {
        fetchUsers(undefined, undefined, undefined, undefined, this.props.childFleetId).then((response) => this.setState({users: response}));
    }

    getUserOptions() {
        return this.state.users.map(u => {
            return {
                value: u.id,
                text: u.displayName,
            }
        })
    }

    render() {
        const {selectedUser, onChange, fleetId, intl, ...clearedProps} = this.props

        return (
            <Select {...clearedProps} options={this.getUserOptions()} value={selectedUser} onChange = {(value) => (onChange(value))} search={true}/>
        )
    }
}

export default injectIntl(UsersSelect)